import React from "react";
import { Translate } from "react-localize-redux";

import InlineNotice from "../../components/InlineNotice";
import { BarbershopQueueStatus, Barbershop } from "../../types";

interface StatusNoticeProps {
  className?: string;
  status: BarbershopQueueStatus;
  queue: Barbershop["queue"];
  isPreOpen?: boolean;
}

interface TitleAndText {
  title: JSX.Element;
  text: JSX.Element;
}

interface Texts {
  timeZero: TitleAndText;
  preOpen: TitleAndText;
  unavailable: TitleAndText;
}

const StatusNotice: React.FC<StatusNoticeProps> = ({
  className,
  status,
  queue,
  isPreOpen: preOpen,
}) => {
  if (status === "unknown") {
    return null;
  }

  const texts: Texts = {
    timeZero: {
      title: <Translate id="barbershop.timeZeroNoticeTitle" />,
      text: <Translate id="barbershop.timeZeroNoticeText" />,
    },
    preOpen: {
      title: <Translate id="barbershop.preOpenNoticeTitle" />,
      text: <Translate id="barbershop.preOpenNoticeText" />,
    },
    unavailable: {
      title: <Translate id="barbershop.notTakingOrdersNoticeTitle" />,
      text: <Translate id="barbershop.notTakingOrdersNoticeText" />,
    },
  };

  const noticeType = getNoticeType(status, queue, preOpen);

  if (!noticeType) {
    return null;
  }

  return (
    <div className={className}>
      <InlineNotice {...texts[noticeType]} />
    </div>
  );
};

export default StatusNotice;

const getNoticeType = (
  status: BarbershopQueueStatus,
  queue: Barbershop["queue"],
  preOpen?: boolean,
): keyof Texts | null => {
  // Store closed but queue is open (pre-opening)
  if (preOpen) {
    return "preOpen";
  }

  if (status === "closed" || status === "full") {
    return "unavailable";
  }

  if (queue === 0) {
    return "timeZero";
  }

  return null;
};
